import { render, staticRenderFns } from "./PNNotes.vue?vue&type=template&id=4b4a294d"
import script from "./PNNotes.vue?vue&type=script&lang=js"
export * from "./PNNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports